export const DEFAULT_LANG = 'en'

export const LOCALE_KEY = 'localeLanguage'

export const MAP_KEY = "454c6d4b534c40fbb29b2a0845e32a55"

export const MAP_API_URL = {
  AUTOCOMPLETE: "https://www.map.gov.hk/gih-ws2/autocomplete",
  SEARCH_PLACES: "https://www.map.gov.hk/gih-ws2/search"
}

export const MAP_LAYER = {
  URL: {
    TOPO: "https://api.hkmapservice.gov.hk/osm/xyz/basemap/WGS84/tile/{z}/{x}/{y}.png?key={KEY}",
    ORTHO: "https://api.hkmapservice.gov.hk/ags/map/worldimagery/WGS84/tile/{z}/{y}/{x}?key={KEY}",

    LOT_LAYER: "https://api.hkmapservice.gov.hk/ags/map/layer/ic1000",
    LOT_LAYER_QUERY: "https://api.hkmapservice.gov.hk/ags/map/layer/ic1000",
    BUILDING_LAYER: "https://api.hkmapservice.gov.hk/ags/map/layer/ib1000/buildings",
    BUILDING_LAYER_QUERY: "https://api.hkmapservice.gov.hk/ags/map/layer/ib1000/buildings",

    IDENTIFY: "https://www.map.gov.hk/gih-ws2/identify",
    // IDENTIFY_LOT: "arcgis2/rest/services/rGeoInfoMap/rgeo_highlight_d00/MapServer/82",
    IDENTIFY_LOT: "/arcgis2/rest/services/rGeoInfoMap/rgeo_highlight_d00/MapServer/84",
    // IDENTIFY_GLA: "arcgis2/rest/services/rGeoInfoMap/rgeo_highlight_d00/MapServer/81",
    IDENTIFY_GLA: "/arcgis2/rest/services/rGeoInfoMap/rgeo_highlight_d00/MapServer/83",
    IDENTIFY_ROAD: "/arcgis2/rest/services/rGeoInfoMap/rgeo_highlight_d00/MapServer/7",
  },

  NAME: {
    LOT_LAYER: "lotLayer",
    LOT_LAYER_QUERY: "lotLayerQuery",
    BUILDING_LAYER: "buildingLayer",
    BUILDING_LAYER_QUERY: "buildingLayerQuery",
    TABLE_LAYER: "tableLayer",

    IDENTIFY: "identify",
    IDENTIFY_LOT: "lotIdentifyQuery",
    IDENTIFY_GLA: "glaIdentifyQuery",
  },
}

export const MAP_LABEL_URL = {
  EN: "https://api.hkmapservice.gov.hk/osm/xyz/label-en/WGS84/tile/{z}/{x}/{y}.png?key={KEY}",
  ZH: "https://api.hkmapservice.gov.hk/osm/xyz/label-tc/WGS84/tile/{z}/{x}/{y}.png?key={KEY}",
}

export const MAP_BASEMAP_NAME = {
  "TOPO": "topo",
  "ORTHO": "ortho",
}

//leaflet marker options
export const LEAFLET = {
  BLUE_ICON: {
    iconUrl: "./lib/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  GOLD_ICON: {
    iconUrl: "./lib/images/marker-icon-orange.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  RED_ICON: {
    iconUrl: "./lib/images/marker-icon-red.png",
    // shadowUrl: "./lib/images/marker-icon-red.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  RED_SEARCH_ICON: {
    iconUrl: "./lib/images/marker-icon-red-search.png",
    // shadowUrl: "./lib/images/marker-icon-red.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  GREEN_ICON: {
    iconUrl: "./lib/images/marker-icon-green.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  GREEN_SEARCH_ICON: {
    iconUrl: "./lib/images/marker-icon-green-search.png",
    // shadowUrl: "./lib/images/marker-icon-red.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
  VIOLEY_ICON: {
    iconUrl: "./lib/images/marker-icon-violey.png",
    // shadowUrl: "./lib/images/marker-icon-red.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  },
}

export const LAYER_TYPE_FORMAT = {
  ARCGIS: "ARCGIS",
  WMS: "WMS",
  WFS: "WFS",
  GEOJSON: "GEOJSON",
  CSV: "CSV",
  KML: "KML",
  GML: "GML",
}

export const LAYER_TYPE_FORMAT_ARRAY = [{
    type: "ARCGIS",
    label: 'ARCGIS Server Web Service',
    disabled: false,
  },
  {
    type: "WMS",
    label: 'WMS OGC Web Serivce',
    disabled: false,
  },
  {
    type: "WFS",
    label: 'WFS OGC Web Serivce',
    disabled: false,
  },
  {
    type: "GEOJSON",
    label: 'GeoJSON',
    disabled: false,
  },
  {
    type: "CSV",
    label: 'CSV',
    disabled: false,
  },
  {
    type: "KML",
    label: 'KML',
    disabled: false,
  },
  {
    type: "GML",
    label: 'GML',
    disabled: false,
  },
  // {
  //   type: "GPX",
  //   label: 'GPX',
  //   disabled: false,
  // },
]

//default column when there is no columns
export const DEFAULT_DYNAMIC_FIELDS = [
  "Name(CHI)",
  "Name(EN)",
  "Address(CHI)",
  "Address(EN)",
  // "Name(Chinese)",
  // "Name(English)",
  // "Address(Chinese)",
  // "Address(English)",
  // "Description(Chinese)",
  // "Description(English)",
];

//user cant input this column name
export const HIDDEN_FIELD_LABELS = {
  LATITUDE: "latitude_lands",
  LONGITUDE: "longitude_lands",
  NORTHING: "northing_lands",
  EASTING: "easting_lands",
  LATLNGS: "latlngs_lands",
  RADIUS: "radius_lands",
  INDEX: "index_lands",
  LEAFLET_ID: "leaflet_id",
  LOT_ID: "lot_id_lands",
  BUILDING_ID: "building_id_lands",
};

//column type
export const FIELD_TYPES = {
  TEXT: "singleText",
  TEXTAREA: "multiText",
  DATE: "date",
  NUMBER: "number",
  ADDRESS_ZH: "address_zh",
  ADDRESS_EN: "address_en",
  NAME_ZH: "name_zh",
  NAME_EN: "name_en"
};
export const FIELD_TYPES_NAME = {
  NAME_ZH: "Name(CHI)",
  NAME_EN: "Name(EN)",
  ADDRESS_ZH: "Address(CHI)",
  ADDRESS_EN: "Address(EN)",
}

export const LAYER_TYPE = {
  CIRCLE: "circle",
  MARKER: "marker",
};

//PLEASE ALSO ADD TO LANGUAGE FILE
export const FILTER_COMMEND = {
  AUTOMATCHED: "$automatched",
  AUTOMATCHEDXY: "$automatchedxy",
  NONGEOTAGGED: "$nongeotagged",
  GEOTAGGED: "$geotagged",
};

export const IMPORT = {
  FORMATS_ARRAY: ["CSV", "GeoJSON", "KML", "GML",
    // "GPX"
  ],
  FORMATS: {
    CSV: "CSV",
    GEOJSON: "GeoJSON",
    KML: "KML",
    GML: "GML",
    // GPX: "GPX",
  },

  OPTIONS_ARRAY: ["Append", "ReplaceAll"],
  OPTIONS: {
    APPEND: "Append",
    REPLACEALL: "ReplaceAll"
  },

  CRS_OPTIONS_ARRAY: ["WGS1984",
    "HK1980"
  ],
  CRS_OPTIONS: {
    WGS1984: "WGS1984",
    HK1980: "HK1980"
  },
  //const formats =  ["GeoJSON", "CSV", "KML", "WKT", "TopoJSON", "Tooltips"]
  // const import_formats = [
  //   "GeoJSON",
  //   "CSV",
  //   "KML",
  //   "GPX",
  //   "WKT",
  //   "TopoJSON",
  //   "Shapefile",
  // ];

  //match the word which is coordinates
  LATITIDE_MATCH: ["latitude", "lat", "y"],
  LONGITUDE_MATCH: ["longitude", "lon", "x"],
  HK80Y_MATCH: ["northing", "north", "hk80y", "y"],
  HK80X_MATCH: ["easting", "east", "hk80x", "x"],
};

export const EXPORT = {
  FORMATS_ARRAY: ["CSV", "GeoJSON", "KML", "GML"],
  FORMATS: {
    CSV: "CSV",
    GEOJSON: "GeoJSON",
    KML: "KML",
    GML: "GML",
  },

  CRS_OPTIONS_ARRAY: ["WGS1984",
    "HK1980"
  ],
  CRS_OPTIONS: {
    WGS1984: "WGS1984",
    HK1980: "HK1980"
  },

  // : ["GeoJSON", "KML", "Shapefile"];
};

export const KML_RESERVED_WORD = [
  "address"
]

export const CRS_TO_EPSG = {
  WGS1984: "EPSG:4326",
  HK1980: "EPSG:2326",
};

export const GEOINFOMAP = {
  ITEM_TYPE: {
    ADDRESS_TYPE: "ADDRESS",
    ADDRESS_TYPE_ST: "ST",
    FACI_TYPE: "FACI",
    LOT_TYPE: "LTYPE",
    LOT_TYPE_GLA: "GLA",
    LOT_TYPE_LOT: "LOT",
  },
}

export const LANG = {
  EN: "en",
  ZH: "zh",
}

export const LAYER_STYLE = {

  TABLE_LAYER: {
    fillColor: "#3388ff",
    fillOpacity: 0.3,
    color: "#3388ff",
    opacity: 0.9,
    weight: 1,
    dashArray: "0",
  },

  TABLE_LAYER_HIGHTLIGHTED: {
    fillColor: "#FFF",
    fillOpacity: 0.3,
    color: "#1B46DB",
    opacity: 0.9,
    weight: 3,
    dashArray: "0",
  },

  TABLE_ITEM_LAYER_SELECTED: {
    fillColor: "#cc842e",
    fillOpacity: 0.3,
    color: "#cc842e",
    opacity: 0.9,
    weight: 3,
    dashArray: "0",
  },

  IDENTIFY_SHAPE_LAYER: {
    fillColor: "#FFF",
    fillOpacity: 0,
    color: "#9a2ecc",
    opacity: 0.9,
    weight: 3,
    dashArray: "0",
  },
}

export const COLUMN_NAME_FILTER = "^[^a-zA-Z]+|[^a-zA-Z0-9_]+";